<template>
  <AppModal @close="onClose()" v-bind="$attrs" v-if="visible">
    <template v-slot:header>Add Network IDT Number</template>
    <form @submit.prevent="onSubmit()">
      <b-alert v-if="existingRecordWarning" variant="warning" show>
        A Network IDT number already exists. Adding a new one will overwrite the existing number.
      </b-alert>

      <div class="form-group">
        <label for="networkIDTNumber">Network IDT Number</label>
        <input
          :class="{'is-invalid': $v.networkIDTNumber.$invalid && isValidating}"
          class="form-control"
          type="number"
          v-model="networkIDTNumber"
        />
        <span class="invalid-feedback" v-if="!$v.networkIDTNumber.required && isValidating">
          Field is required
        </span>
      </div>
    </form>

    <template v-slot:footer>
      <button :disabled="isSubmitting" @click.prevent="onSubmit()" class="btn btn-primary" type="submit">
        Submit
      </button>
      <button :disabled="isSubmitting" @click="onClose()" class="btn btn-danger" type="button">
        Close
      </button>
    </template>
  </AppModal>
</template>

<script>
import AppModal from "@/components/shared/AppModal";
import NetworkIDTService from "@/services/NetworkIDTsService";
import { required } from "vuelidate/lib/validators";
import { ToastType } from "@/services/models/shared/ToastType";

export default {
  components: {
    AppModal
  },
  data() {
    return {
      networkIDTNumber: null,
      isSubmitting: false,
      isValidating: false,
      existingRecordWarning: false,  
    };
  },
  props: {
    visible: {
      required: false,
      default: false,
    },
  },
  validations: {
    networkIDTNumber: {
      required,
    },
  },
  watch: {
    visible(newValue) {
      if (newValue) {
        this.checkIfIDTNumberExists();
      } else {
        this.onClose();
      }
    },
    networkIDTNumber() {
      if (this.isValidating) {
        this.$v.networkIDTNumber.$reset();
       }
    }
  },
  methods: {
    async checkIfIDTNumberExists() {
      try {
        const numberExists = await NetworkIDTService.checkNetworkIDTNumbersExist();

        if (numberExists) {
          this.existingRecordWarning = true;
        } else {
          this.existingRecordWarning = false;
        }
      } catch (error) {
        this.alert(ToastType.Danger, "Unable to check for existing network IDT number. Add a new number at your own risk.");
      }
    },

    async onSubmit() {
      this.isValidating = true;
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      this.isSubmitting = true;
      NetworkIDTService.createNetworkIDTNumber(this.networkIDTNumber)
        .then(() => {
          this.alert(ToastType.Success, "Network IDT Number added successfully");
          this.onClose();
        })
        .catch(() => {
          this.alert(ToastType.Danger, "Unable to add network IDT number");
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },

    onClose() {
      this.networkIDTNumber = null;
      this.isValidating = false;
      this.isSubmitting = false;
      this.existingRecordWarning = false;
      this.$emit("close");
    }
  },
};
</script>